import apiService from "service/api";
// import { IAddUserForm } from "types";

export const getAllShots = async (
  hfId: number,
  page: any,
  size: number,
  params: {
    branch_name?: string;
    client?: string;
    client_ino_id?: string;
    client_id?: number;
    statusType?: string;
    vaccinated_on?: string;
    vaccination?: number;
    vaccine_batch_number?: string;
    vaccine_name?: string;
  } = {}
) => {
  const queryParams = new URLSearchParams();

  // Add pagination parameters
  queryParams.append("page", page.toString());
  queryParams.append("size", size.toString());

  // Add optional filter parameters
  if (params.client) queryParams.append("client", params.client);
  if (params.client_ino_id) queryParams.append("client_ino_id", params.client_ino_id);
  if (params.statusType) queryParams.append("shot_status", params.statusType);
  if (params.vaccinated_on) queryParams.append("vaccinated_on", params.vaccinated_on);
  if (params.vaccine_batch_number) queryParams.append("vaccine_batch_number", params.vaccine_batch_number);
  if (params.vaccine_name) queryParams.append("vaccine_name", params.vaccine_name);
  if (params.vaccination !== undefined)
    queryParams.append("vaccination", params.vaccination.toString());
  if (params.client_id !== undefined)
    queryParams.append("client_id", params.client_id.toString());

  let url = `/vaccine/${hfId}/shots/?${queryParams.toString()}`;
  console.log(url);

  const method = "get";
  return apiService(url, method, null, true, {});
};

// export const createShot = async (
//   hfId: number,
//   formData: Record<string, any>
// ) => {
//   const url = `/healthfacilities/${hfId}/branch/add-enduser/`;

//   return apiService(url, "POST", formData, true);
// };
